import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import onVisibilityChange from "visibility-change-ponyfill";

import { processingAtLogin, login, deleteAllUserData } from "common/actions";
import firebase, {
  firstLoginCheck,
} from "common/assets/js/firebase";
import "firebase/compat/performance";
import { User } from "common/models/user";
import { Common } from "common/models/common";

import Login from "pages/Login";
import Editor from "pages/Editor";

const firebasePerformance = (firebase as any).performance();
type PageProps = {
  user?: User;
  common?: Common;
};
type PageDispatch = {
  processingAtLogin?: () => void;
  login?: ({ currentUser, isFirstLogin }) => void;
  deleteAllUserData?: () => void;
};
type State = {
  isLoginChecked: Boolean;
};

class App extends React.Component<PageProps & PageDispatch, State> {
  private _unsubscribeAuth: (() => void) | null = null;

  constructor(props) {
    super(props);
    this.state = {
      isLoginChecked: false,
    };
  }

  async componentDidMount() {
    const perfTrace = firebasePerformance.trace("customTraceName");
    perfTrace.start();

    this._unsubscribeAuth = firebase.auth().onAuthStateChanged(async loginUserData => {
      if (loginUserData) {
        const isFirstLogin = await firstLoginCheck();
        this.props.login({ currentUser: loginUserData, isFirstLogin });
      } else {
        if (this.props.user.uid) {
          alert("ログインセッションが切れました。再度ログインしてください。");
        }
        this.props.deleteAllUserData();
      }
      if (!this.state.isLoginChecked) {
        this.setState({ isLoginChecked: true });
        perfTrace.stop();
      }
    });

    onVisibilityChange(this._onVisibilityChange);
  }

  componentWillUnmount() {
    if (this._unsubscribeAuth) {
      this._unsubscribeAuth();
    }
    onVisibilityChange.remove(this._onVisibilityChange);
  }

  _onVisibilityChange = () => {
    if (!document.hidden && this.props.user.uid) {
      //tabが表示のタイミングでデータ同期
      this.props.processingAtLogin();
    }
  };

  render() {
    const { email } = this.props.user;
    const { isSynced } = this.props.common;
    const { isLoginChecked } = this.state;

    // if (process.env.NODE_ENV === "development") {
    //   return <Editor />;
    // }
    if (!isLoginChecked) {
      return (
        <Loading>
          <p>ログイン状態をチェックしています...</p>
        </Loading>
      );
    }

    if (email) {
      if (!isSynced) {
        return (
          <Loading>
            <p>データを同期しています...</p>
          </Loading>
        );
      }
      return <Editor />;
    } else {
      return <Login />;
    }
  }
}

export default connect<PageProps, PageDispatch>(
  ({ user, common }: any) => ({ user, common }),
  {
    processingAtLogin,
    login,
    deleteAllUserData,
  }
)(App);

const Loading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
